import { settings } from "./settings";

const fetchWrapper = async (market, locale) => {
  try {
    const res = await fetch(`${settings.fragmentApi}/fragment/wrapper?market=${market}&locale=${locale}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (e) {
    console.error("Failed to load wrapper:", e);
    return {};
  }
};

const insertHtml = (id, html) => {
  const el = document.getElementById(id);
  if (el) el.innerHTML = html;
  else console.warn(`Container with id "${id}" not found.`);
};

const addTuiWrapper = async () => {
  const market = (window.location.hostname.match(/tui\.(se|dk|fi|no)/)?.[1]) || "se";
  const locale = `${settings?.language || 'sv'}-${market}`;

  const data = await fetchWrapper(market, locale);
  insertHtml("header", data.headerHtml || "");
  insertHtml("footer", data.footerHtml || "");
};

export default addTuiWrapper;
